import { Chain, ChainClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { ImageSetter } from '../MaterialEditor/ImageSetter';

export function LogoAdmin(props: {
    chain: Chain,
    onChange: () => void
}) {

    const chainClient = useClient(ChainClient);

    async function setLogo(f: File) {
        const extension = f.type.split("/")[1];
        await chainClient.setLogo(props.chain.id,
            extension,
            { data: f, fileName: f.name }
        );
        props.onChange();
    }


    return (
        <>

            <ImageSetter
                url={props.chain.logoUrl ?? null}
                onSet={setLogo} />

        </>
    );
}
